import * as Sentry from '@sentry/browser';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppProviders } from './context';
import BrowserChecker from './layout/BrowserChecker';
import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <BrowserChecker>
    <AppProviders>
      <App />
    </AppProviders>
  </BrowserChecker>
);

serviceWorker.unregister();
